import { DesignSystemProvider, defaultTheme } from '@redbubble/design-system';
import { localeLoader, withIntlApp } from '@redbubble/next-i18n';
import React from 'react';
import { NavigationProvider } from './navigation-provider';
import { PagePropsProvider } from './page-props-provider';
import { RudderstackProvider, } from './rudderstack/rudderstack-provider';
import { UserInfoProvider } from './user-info-provider';
function RBProvider(_a) {
    var pageProps = _a.pageProps, rudderstackProps = _a.rudderstackProps, children = _a.children;
    return (React.createElement(NavigationProvider, null,
        React.createElement(PagePropsProvider, { pageProps: pageProps },
            React.createElement(UserInfoProvider, { userInfo: pageProps.userInfo },
                React.createElement(RudderstackProvider, { configUrl: rudderstackProps.configUrl, writeKey: rudderstackProps.writeKey, dataplaneUrl: rudderstackProps.dataplaneUrl, enabled: rudderstackProps.enabled, deniedConsent: rudderstackProps.deniedConsent, allowedConsent: rudderstackProps.allowedConsent },
                    React.createElement(DesignSystemProvider, { config: { theme: defaultTheme } }, children))))));
}
export default withIntlApp(localeLoader)(RBProvider);
